import { render, staticRenderFns } from "./arrow-down-light.vue?vue&type=template&id=1d515f1f&"
import script from "./arrow-down-light.vue?vue&type=script&lang=js&"
export * from "./arrow-down-light.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d515f1f')) {
      api.createRecord('1d515f1f', component.options)
    } else {
      api.reload('1d515f1f', component.options)
    }
    module.hot.accept("./arrow-down-light.vue?vue&type=template&id=1d515f1f&", function () {
      api.rerender('1d515f1f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/arrow-down-light.vue"
export default component.exports